/* eslint-disable @typescript-eslint/no-unused-vars */
import { LibraryIssue } from '../../../../../common/interfaces/Issue'
import { filterIssues } from '../../utils/issueUtils'
import { descendingSort } from '../../utils/sort'
import Carousel from 'react-multi-carousel'
import dayjs from 'dayjs'
import styles from './styles'
import { IssuesProps } from './type'
import {
  REMOVE_ARROR_ON_LARGE_IMAGE_DEVICE,
  responsiveLarge
} from '../../constants'
import useWindowSize from '../../hooks/useWindowResize'
import SkeletonIssueCard from '../skeleton/SkeletonIssueCard'
import ScrollIndicator from '../carousel/ScrollIndicator'

const AllIssues = (props: IssuesProps) => {
  const { issues, title, startDate, endDate, onClick } = props
  const allIssues = filterIssues(issues, title, startDate, endDate)
  const sortedIssues = descendingSort(allIssues, 'issueDate')
  const { isLandscape } = useWindowSize()

  return sortedIssues.length > 0 ? (
    <div key={title} style={{ marginBottom: 40 }}>
      <div
        style={{
          ...styles.title,
          fontSize: 24,
          fontWeight: 600,
          marginBottom: 20
        }}
        className={'section-label'}
      >
        Latest Issues ({sortedIssues.length})
      </div>
      <div className="carousel-container">
        <Carousel
          ssr
          responsive={responsiveLarge(isLandscape)}
          removeArrowOnDeviceType={REMOVE_ARROR_ON_LARGE_IMAGE_DEVICE}
          partialVisible
        >
          {sortedIssues.map((i: LibraryIssue) => {
            const {
              coverImageUrl,
              magTitle,
              issueDate,
              entitlementId = '',
              name = ''
            } = i
            return (
              <div
                style={{
                  height: '100%',
                  padding: '0 10px',
                  cursor: 'pointer',
                  transition: 'transform 0.2s ease-in-out'
                }}
                key={entitlementId}
                className="issue-card-large"
              >
                <div
                  className={'image-container'}
                  style={{
                    borderRadius: 16,
                    overflow: 'hidden',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    marginBottom: 12,
                    padding: '16px',
                    transition: 'box-shadow 0.2s ease-in-out',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <img
                    draggable={false}
                    key={coverImageUrl}
                    style={{ ...styles.productImageLarge, borderRadius: 0 }}
                    src={coverImageUrl}
                    alt={magTitle}
                    onClick={() => onClick(entitlementId)}
                  />
                </div>
                <div
                  className={'title'}
                  style={{ fontSize: 18, fontWeight: 500, marginBottom: 6 }}
                >
                  {magTitle}
                </div>
                <div
                  className={'description'}
                  style={{ color: '#666', fontSize: 14 }}
                >
                  {name || dayjs(issueDate).format('MMMM D, YYYY')}
                </div>
              </div>
            )
          })}
        </Carousel>
        <ScrollIndicator
          show={window.innerWidth <= 768 && sortedIssues.length > 1}
        />
      </div>
    </div>
  ) : null
}

export default AllIssues
